import { render, staticRenderFns } from "./history-list.vue?vue&type=template&id=233c2ed6&scoped=true&"
import script from "./history-list.vue?vue&type=script&lang=js&"
export * from "./history-list.vue?vue&type=script&lang=js&"
import style0 from "./history-list.vue?vue&type=style&index=0&id=233c2ed6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "233c2ed6",
  null
  
)

export default component.exports